import React from 'react';

import { Link } from '~/lib/react-router-dom';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, List, ListItemButton, ListItemText, Typography } from '@mui/material';

import mergeRoomPolicyNames from '../../../utils/mergeRoomPolicyNames';

type Props = {
  offer: {
    result: App.Offer;
  };
  propertyData: any;
};

export default function RoomPolicyPane({ offer, propertyData }: Props) {
  const roomPolicyDetails = mergeRoomPolicyNames(offer.result.packages, propertyData);
  const editBasePath = `/edit-offers/${offer.result.id_salesforce_external}/room-policies`;

  return (
    <span>
      <h1 className="page-header">Room Policy</h1>
      <Box>
        <List disablePadding>
          {roomPolicyDetails.map((roomPolicy, index) => (
            <ListItemButton
              key={`${roomPolicy.id}-${index}`}
              component={Link}
              to={editBasePath}
              divider={index < roomPolicyDetails.length - 1}
            >
              <ListItemText
                primary={
                  <Typography sx={{ textTransform: 'uppercase', fontSize: 18, fontWeight: 300 }}>
                    {roomPolicy.room_type_name}
                  </Typography>
                }
              />
              <ChevronRightIcon color="action" />
            </ListItemButton>
          ))}
        </List>
      </Box>
    </span>
  );
}
